<mat-form-field
  [appearance]="appearance"
  [class]="[hideRequiredMarker ? 'hideRequiredMarker' : '', classes]"
>
  <mat-label>{{ label }}</mat-label>
  <input matInput
       [placeholder]="placeholder"
       [formControl]="control"
       [type]="hide() ? 'password' : 'text'"
       [required]="required"
       [autocomplete]="autocomplete"
  />
 <button
    mat-icon-button
    matSuffix
    type="button"
    (click)="toggleVisibility($event)"
    [attr.aria-label]="'Hide password'"
    [attr.aria-pressed]="hide()"
  >
    <mat-icon>{{ hide() ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>
  @if (control.hasError('required')){
    <mat-error>{{label? label : 'This field' }} is <strong>required</strong></mat-error>
  }
</mat-form-field>
